import { icons } from '../../assets/assets';
import GameMaterialItem from './GameMaterialItem';
import React from 'react';

export default class DocumentGameMaterial extends GameMaterialItem {
  constructor(props) {
    super(props);
    this.state.icons = [icons.link];

    this.renderTitle = () => {
      return <p>{this.props.item.title}</p>;
    };

    this.handleClick = (ev) => {
      window.open(this.props.item.alternateUrl, '_blank');
    };
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/LinkMaterialItem.js